<script>
  import Router from 'svelte-spa-router'
  import {push} from 'svelte-spa-router'
  import Notifications from 'svelte-notifications'

  import Header from '$comps/Header.svelte'
  import Nav from '$comps/Nav.svelte'

  import LoginPage from './pages/Login.svelte'
  import ConfigsPage from './pages/Configs.svelte'
  import Notification from './components/Notification.svelte';
  import { token } from '$services/stores.js'

  let isSideNavOpen = false;

  const routes = {
    '/login': LoginPage,
    '/': ConfigsPage,
    '/configs': ConfigsPage,
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://unpkg.com/carbon-components-svelte/css/g100.css"
    />
</svelte:head>


<main>
  <Notifications item={Notification}>
    <Header />
    <Nav />

    <div id="main-container">
      {#if $token !== ''}
	<Router {routes} />
      {:else}
	<LoginPage />
      {/if}
    </div>
  </Notifications>
</main>

<style lang="scss">
  #main-container {
    width: 97vw;
    position: absolute;
    top: 5vh;
    left: 3vw;
  }
</style>




